import { fetchWithAuth } from "../utils/fetch/FetchWithAuth";

export const ReturnablePackagingService = {
    list: () => {
        const url = `/portal/inventory/product/returnable`;
        return fetchWithAuth(url, { method: 'GET' });
    }
};